import React, { useEffect, useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  TextField,
} from '@mui/material';
import Label from '@mui/material/FormLabel';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import dayjs from 'dayjs';
import DateComponent from '../../../Registrationform/components/dateComponent';
import { useDispatch, useSelector } from 'react-redux';
import { setPatientData } from '../../../../actions';
import { makeStyles } from '@mui/styles';

// Styles for the form
const useStyles = makeStyles({
  formContainer: {
    padding: '20px',
  },
  formRow: {
    // display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '10px',
  },
  inputField: {
    width: '150px',
    border: 'none',
    padding: '1px',
    boxSizing: 'border-box',
    fontSize: '12px',
  },
  addRowButton: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '10px',
  },
});

export default function TriggerTable({
  triggerDate,
  triggerTime,
  handleDateChange,
  handleTimeChange,
}) {
  const classes = useStyles();
  const patientData = useSelector((state) => state.clinicalReducer);
  const [rows, setRows] = useState([]);
  const dispatch = useDispatch();

  const handleAddRow = () => {
    setRows([...rows, { medicine: '', dose: '' }]);
  };

  const handleDeleteRow = (index) => {
    const newRows = rows.filter((_, i) => i !== index);
    setRows(newRows);
  };

  useEffect(() => {
    if (patientData.currentCycle.fmsData.triggerTable) {
      setRows(patientData.currentCycle.fmsData.triggerTable);
    }
  }, [patientData]);

  const handleInputChange = (index, event) => {
    const { name, value } = event.target;
    const newRows = [...rows];
    newRows[index][name] = value;
    setRows(newRows);
    dispatch(setPatientData('currentCycle.fmsData.triggerTable', newRows));
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Label style={{ width: '200px' }}>Trigger:</Label>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            gap: '4px',
          }}
        >
          <div style={{ flex: '1 1' }}>
            <label htmlFor="triggerDate">Date</label>
            <DateComponent
              id="triggerDate"
              selectedDate={triggerDate ? dayjs(triggerDate) : null}
              handleDateChange={(date, dateString) =>
                handleDateChange(dateString)
              }
            />
          </div>
          <div className={`form-group`}>
            <label htmlFor="triggerTime">{'Trigger Time'}</label>
            <TextField
              className={classes.inputField}
              type="time"
              variant="standard"
              value={triggerTime}
              onChange={(e) => handleTimeChange(e.target.value)}
            />
            {/* <input
              required={false}
              type={'text'}
              className="form-control"
              name={'triggerTime'}
              value={triggerTime}
              onChange={(e) => handleTimeChange(e.target.value)}
            /> */}
          </div>
        </div>
      </div>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow sx={{ height: '40px' }}>
              <TableCell>
                Medicine
                <IconButton
                  onClick={handleAddRow}
                  size="small"
                  style={{ marginLeft: 8 }}
                >
                  <AddIcon />
                </IconButton>
              </TableCell>
              <TableCell>Dose</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, index) => (
              <TableRow key={index} sx={{ height: '40px' }}>
                <TableCell>
                  <TextField
                    name="medicine"
                    value={row.medicine}
                    onChange={(event) => handleInputChange(index, event)}
                    variant="outlined"
                    size="small"
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    name="dose"
                    value={row.dose}
                    onChange={(event) => handleInputChange(index, event)}
                    variant="outlined"
                    size="small"
                  />
                </TableCell>
                <TableCell>
                  <IconButton
                    onClick={() => handleDeleteRow(index)}
                    size="small"
                    color="error"
                  >
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
